import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { DynamicComponentEditFormService } from './service/dynamic-component-edit-form.service';
import { DynamicComponentEditFormGetMetaInfoCol, DynamicComponentEditFormGetMetaInfoRequest, DynamicComponentEditFormGetModelRequest } from './service/model/models';
import { DynamicComponentEditFormUpdateRequest } from './service/model/dynamicComponentEditFormUpdateRequest';
import { DynamicComponentEditFormAddRequest } from './service/model/dynamicComponentEditFormAddRequest';
@Component({
    selector: 'lc-edit-form',
    templateUrl: './lc-edit-form.component.html',
    providers: [DynamicComponentEditFormService]
})
export class LcEditFormComponent implements OnInit {
    parentModel:any;
    parentId:any;
    model: any= {};
    id: string;
    /**
     * 窗体id
     */
    windowFormId: string;
    /**
     * 编辑列
     */
    cols: DynamicComponentEditFormGetMetaInfoCol[]=[];
    constructor(
        private msg: NzMessageService,
        private modal: NzModalRef,
        private service: DynamicComponentEditFormService
    ) { }

   async ngOnInit() {
       const request: DynamicComponentEditFormGetMetaInfoRequest = {};
       request.id = this.windowFormId;
       const res = await this.service.getMetaInfo(request,{isCache: true});
       this.cols= [...res.data.cols];
       this.loadData();

   }
   loadData(){
        console.log(this.id);
       if (this.id) {
           const request: DynamicComponentEditFormGetModelRequest = {};
           request.windowFormId = this.windowFormId;
           request.id = this.id;
           this.service.getModel(request).then(res=>{
               this.model = res.data;
           });
       }
   }
    saveOnClick() {
        //格式化数据
        this.formartData();
        if (this.id) {
            const request: DynamicComponentEditFormUpdateRequest = {};
            request.model = this.model;
            request.windowFormId = this.windowFormId;
            request.id = this.id;
            this.service.update(request).then(res => {
                if (res.code === 1) {
                    this.msg.success('Success');
                    this.modal.close(res);
                } else {
                    this.msg.error(res.message);
                }
            });
        } else {
            const request: DynamicComponentEditFormAddRequest = {};
            request.model = this.model;
            request.windowFormId = this.windowFormId;
            this.service.add(request).then(res => {
                if (res.code === 1) {
                    this.msg.success('Success');
                    this.modal.close(res);
                } else {
                    this.msg.error(res.message);
                }
            });
        }
    }
    private formartData(){
        this.cols.forEach(f=>{
            if(f.formatScript) {
                const value= new Function('model','parentModel','parentId','that',f.formatScript)(this.model,this.parentModel,this.parentId,this);
                if(value!=null){
                    this.model[f.colName]=value;
                }
            }
        });
    }
    closeOnClick() {
        this.modal.close();
    }
}
